import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewRef } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Bank } from "../core/model/bank";
import { BankService } from "../core/service/bank.service";

@Component({
  selector: "app-bank",
  templateUrl: "./bank.component.html",
  styleUrls: ["./bank.component.scss"],
})
export class BankComponent implements OnInit, OnDestroy {
  banks: Bank[] = [];
  loading = true;
  errorMsg: string;

  private destroy$ = new Subject<void>();

  constructor(
    private _router: Router,
    private _bankService: BankService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getBanks();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getBanks() {
    this.loading = true;
    this.errorMsg = null;
    this._bankService
      .getAllBanks()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.banks = data || [];
          this.loading = false;
          this.safeDetectChanges();
        },
        (error) => {
          console.log(error);
          this.banks = [];
          this.loading = false;
          this.errorMsg = "Impossible de charger les agences";
          this.safeDetectChanges();
        }
      );
  }

  private safeDetectChanges(): void {
    const view = this.cdr as ViewRef;
    if (view && !view.destroyed) {
      this.cdr.detectChanges();
    }
  }

  add(): void {
    this._router.navigate(["/parametrage/bank/add-bank"]);
  }
}
